import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.searchIcon = this.$('search-icon')[0];
        this.searchForm = this.$('search-form')[0];

        this.searchIcon.addEventListener('click', () => {
            this.searchForm.classList.toggle('active');
        });

    }
}
